import { render, staticRenderFns } from "./ConsultaItemBemPermanenteEdit.vue?vue&type=template&id=232c3d7a"
import script from "./ConsultaItemBemPermanenteEdit.vue?vue&type=script&lang=js"
export * from "./ConsultaItemBemPermanenteEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports